

export const listing_fields = [
    "wifi_network",
    "wifi_password",
    "checkin_time",
    "checkout_time",
    "name",
    "new_tags",
    "names",
    "description",
    "short_description",
    "rules",
    "agreement",
    "address"
]

export const content_config = [
    {
        "title": "Addon Services",
        "subtitle": "Manage your services",
        "content_type": "addon_services",
        "form_schema": {
            "title": "IntegrationSpecModel",
            "type": "object",
            "properties": {
                "title": {
                    "title": "Title",
                    "type": "string"
                },
                "service": {
                    "$ref": "#/definitions/ServiceEnum"
                },
                "provider": {
                    "$ref": "#/definitions/ProviderEnum"
                },
                "icon": {
                    "title": "Icon",
                    "type": "string"
                },
                "picture_url": {
                    "title": "Picture Url",
                    "type": "string"
                },
                "details": {
                    "title": "Details",
                    "type": "string"
                },
                "how_it_works": {
                    "title": "How It Works",
                    "type": "string"
                },
                "includes": {
                    "title": "Includes",
                    "default": [],
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/IncludedFeatureModel"
                    }
                },
                "signup_type": {
                    "title": "Signup Type",
                    "enum": [
                        "seam",
                        "redirect",
                        "api_key"
                    ],
                    "type": "string"
                },
                "signup_text": {
                    "title": "Signup Text",
                    "type": "string"
                },
                "signup_fields": {
                    "title": "Signup Fields",
                    "default": {},
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/SigupFieldModel"
                    }
                },
                "policies": {
                    "title": "Policies",
                    "default": [],
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    }
                },
                "supported_features": {
                    "$ref": "#/definitions/PMSFormProperties"
                }
            },
            "required": [
                "service"
            ],
            "definitions": {
                "ServiceEnum": {
                    "title": "ServiceEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "obj",
                        "act",
                        "pms",
                        "cb",
                        "msg",
                        "phn",
                        "sl",
                        "kc",
                        "ast",
                        "pay",
                        "ver",
                        "pr",
                        "bk",
                        "ls",
                        "sms",
                        "billing",
                        "groups",
                        "exp",
                        "chargebee",
                        "autoresponder"
                    ],
                    "type": "string"
                },
                "ProviderEnum": {
                    "title": "ProviderEnum",
                    "description": "Service providers",
                    "enum": [
                        "enso",
                        "partee",
                        "flexipass",
                        "autohost",
                        "superhog",
                        "chekin",
                        "salto",
                        "interphone",
                        "august",
                        "schlage",
                        "smart",
                        "amazon",
                        "keycafe",
                        "stripe",
                        "twilio",
                        "whatsapp",
                        "nuki",
                        "igloo",
                        "yale",
                        "minut",
                        "ttlock",
                        "kwikset",
                        "chatgpt",
                        "4suites",
                        "wyze",
                        "dormakaba_oracode",
                        "lockly",
                        "noiseaware",
                        "brivo",
                        "tedee",
                        "akiles",
                        "latch",
                        "viator",
                        "my_2n",
                        "ultraloq",
                        "ab",
                        "abnb",
                        "vrbo",
                        "gy",
                        "bks",
                        "mews",
                        "ha",
                        "ru",
                        "b24",
                        "ba",
                        "cb",
                        "hfl",
                        "ifr",
                        "impl",
                        "lvnd",
                        "myvr",
                        "opra",
                        "smrt",
                        "stay",
                        "st",
                        "trk",
                        "lg",
                        "lmpm",
                        "lt",
                        "htf",
                        "cs",
                        "ownrz",
                        "avt",
                        "chargebee"
                    ],
                    "type": "string"
                },
                "IncludedFeatureModel": {
                    "title": "IncludedFeatureModel",
                    "type": "object",
                    "properties": {
                        "header": {
                            "title": "Header",
                            "type": "string"
                        },
                        "subheader": {
                            "title": "Subheader",
                            "type": "string"
                        }
                    },
                    "required": [
                        "header"
                    ]
                },
                "SigupFieldModel": {
                    "title": "SigupFieldModel",
                    "type": "object",
                    "properties": {
                        "name": {
                            "title": "Name",
                            "type": "string"
                        }
                    },
                    "required": [
                        "name"
                    ]
                },
                "FeatureSupportEnum": {
                    "title": "FeatureSupportEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "supported",
                        "unsupported_by_pms",
                        "unsupported_by_enso",
                        "unknown",
                        "not_applicable"
                    ],
                    "type": "string"
                },
                "BookingFieldsSpecModel": {
                    "title": "BookingFieldsSpecModel",
                    "type": "object",
                    "properties": {
                        "booking_multi_guest_support": {
                            "title": "Booking Multi Guest Support",
                            "enum": [
                                "one_guest_multiple_bookings",
                                "one_guest_one_booking",
                                "unknown"
                            ],
                            "type": "string"
                        },
                        "booking_multi_guest_support_notes": {
                            "title": "Booking Multi Guest Support Notes",
                            "type": "string"
                        },
                        "checkin_date": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "checkin_date_notes": {
                            "title": "Checkin Date Notes",
                            "type": "string"
                        },
                        "checkin_time": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "checkin_time_notes": {
                            "title": "Checkin Time Notes",
                            "type": "string"
                        },
                        "checkout_date": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "checkout_date_notes": {
                            "title": "Checkout Date Notes",
                            "type": "string"
                        },
                        "checkout_time": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "checkout_time_notes": {
                            "title": "Checkout Time Notes",
                            "type": "string"
                        },
                        "currency": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "currency_notes": {
                            "title": "Currency Notes",
                            "type": "string"
                        },
                        "device_codes": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "device_codes_notes": {
                            "title": "Device Codes Notes",
                            "type": "string"
                        },
                        "fees": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "fees_notes": {
                            "title": "Fees Notes",
                            "type": "string"
                        },
                        "guest_name": {
                            "default": "supported",
                            "allOf": [
                                {
                                    "$ref": "#/definitions/FeatureSupportEnum"
                                }
                            ]
                        },
                        "guest_name_notes": {
                            "title": "Guest Name Notes",
                            "type": "string"
                        },
                        "guest_country": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "guest_country_notes": {
                            "title": "Guest Country Notes",
                            "type": "string"
                        },
                        "guest_email": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "guest_email_notes": {
                            "title": "Guest Email Notes",
                            "type": "string"
                        },
                        "guest_phone": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "guest_phone_notes": {
                            "title": "Guest Phone Notes",
                            "type": "string"
                        },
                        "guest_language": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "guest_language_notes": {
                            "title": "Guest Language Notes",
                            "type": "string"
                        },
                        "host_payout_amount": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "host_payout_amount_notes": {
                            "title": "Host Payout Amount Notes",
                            "type": "string"
                        },
                        "inquiries": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "inquiries_notes": {
                            "title": "Inquiries Notes",
                            "type": "string"
                        },
                        "nightly_rate": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "nightly_rate_notes": {
                            "title": "Nightly Rate Notes",
                            "type": "string"
                        },
                        "number_of_adults": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "number_of_adults_notes": {
                            "title": "Number Of Adults Notes",
                            "type": "string"
                        },
                        "number_of_children": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "number_of_children_notes": {
                            "title": "Number Of Children Notes",
                            "type": "string"
                        },
                        "number_of_pets": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "number_of_pets_notes": {
                            "title": "Number Of Pets Notes",
                            "type": "string"
                        },
                        "ota_confirmation_code": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "ota_confirmation_code_notes": {
                            "title": "Ota Confirmation Code Notes",
                            "type": "string"
                        },
                        "payment_status": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "payment_status_notes": {
                            "title": "Payment Status Notes",
                            "type": "string"
                        },
                        "status": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "status_notes": {
                            "title": "Status Notes",
                            "type": "string"
                        },
                        "tags": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "tags_notes": {
                            "title": "Tags Notes",
                            "type": "string"
                        },
                        "taxes": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "taxes_notes": {
                            "title": "Taxes Notes",
                            "type": "string"
                        },
                        "total_guest_paid": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "total_guest_paid_notes": {
                            "title": "Total Guest Paid Notes",
                            "type": "string"
                        },
                        "enso_guest_data": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "enso_guest_data_notes": {
                            "title": "Enso Guest Data Notes",
                            "type": "string"
                        },
                        "enso_upsell_financial_data": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "enso_upsell_financial_data_notes": {
                            "title": "Enso Upsell Financial Data Notes",
                            "type": "string"
                        },
                        "enso_fees_financial_data": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "enso_fees_financial_data_notes": {
                            "title": "Enso Fees Financial Data Notes",
                            "type": "string"
                        },
                        "enso_boarding_pass_link": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "enso_boarding_pass_link_notes": {
                            "title": "Enso Boarding Pass Link Notes",
                            "type": "string"
                        },
                        "custom_fields": {
                            "title": "Custom Fields",
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "all_custom_fields": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "custom_fields_notes": {
                            "title": "Custom Fields Notes",
                            "type": "string"
                        },
                        "dual_sync_fields": {
                            "title": "Dual Sync Fields",
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "dual_sync_notes": {
                            "title": "Dual Sync Notes",
                            "type": "string"
                        }
                    },
                    "required": [
                        "booking_multi_guest_support",
                        "checkin_date",
                        "checkin_time",
                        "checkout_date",
                        "checkout_time",
                        "currency",
                        "device_codes",
                        "fees",
                        "guest_country",
                        "guest_email",
                        "guest_phone",
                        "guest_language",
                        "host_payout_amount",
                        "inquiries",
                        "nightly_rate",
                        "number_of_adults",
                        "number_of_children",
                        "number_of_pets",
                        "ota_confirmation_code",
                        "payment_status",
                        "status",
                        "tags",
                        "taxes",
                        "total_guest_paid",
                        "enso_guest_data",
                        "enso_upsell_financial_data",
                        "enso_fees_financial_data",
                        "enso_boarding_pass_link",
                        "custom_fields",
                        "all_custom_fields",
                        "dual_sync_fields"
                    ]
                },
                "BookingPushFieldsSpecModel": {
                    "title": "BookingPushFieldsSpecModel",
                    "type": "object",
                    "properties": {
                        "booking_multi_guest_support": {
                            "title": "Booking Multi Guest Support",
                            "enum": [
                                "one_guest_multiple_bookings",
                                "one_guest_one_booking",
                                "unknown"
                            ],
                            "type": "string"
                        },
                        "booking_multi_guest_support_notes": {
                            "title": "Booking Multi Guest Support Notes",
                            "type": "string"
                        },
                        "checkin_date": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "checkin_date_notes": {
                            "title": "Checkin Date Notes",
                            "type": "string"
                        },
                        "checkin_time": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "checkin_time_notes": {
                            "title": "Checkin Time Notes",
                            "type": "string"
                        },
                        "checkout_date": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "checkout_date_notes": {
                            "title": "Checkout Date Notes",
                            "type": "string"
                        },
                        "checkout_time": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "checkout_time_notes": {
                            "title": "Checkout Time Notes",
                            "type": "string"
                        },
                        "currency": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "currency_notes": {
                            "title": "Currency Notes",
                            "type": "string"
                        },
                        "device_codes": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "device_codes_notes": {
                            "title": "Device Codes Notes",
                            "type": "string"
                        },
                        "fees": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "fees_notes": {
                            "title": "Fees Notes",
                            "type": "string"
                        },
                        "guest_name": {
                            "default": "supported",
                            "allOf": [
                                {
                                    "$ref": "#/definitions/FeatureSupportEnum"
                                }
                            ]
                        },
                        "guest_name_notes": {
                            "title": "Guest Name Notes",
                            "type": "string"
                        },
                        "guest_country": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "guest_country_notes": {
                            "title": "Guest Country Notes",
                            "type": "string"
                        },
                        "guest_email": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "guest_email_notes": {
                            "title": "Guest Email Notes",
                            "type": "string"
                        },
                        "guest_phone": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "guest_phone_notes": {
                            "title": "Guest Phone Notes",
                            "type": "string"
                        },
                        "guest_language": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "guest_language_notes": {
                            "title": "Guest Language Notes",
                            "type": "string"
                        },
                        "host_payout_amount": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "host_payout_amount_notes": {
                            "title": "Host Payout Amount Notes",
                            "type": "string"
                        },
                        "inquiries": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "inquiries_notes": {
                            "title": "Inquiries Notes",
                            "type": "string"
                        },
                        "nightly_rate": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "nightly_rate_notes": {
                            "title": "Nightly Rate Notes",
                            "type": "string"
                        },
                        "number_of_adults": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "number_of_adults_notes": {
                            "title": "Number Of Adults Notes",
                            "type": "string"
                        },
                        "number_of_children": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "number_of_children_notes": {
                            "title": "Number Of Children Notes",
                            "type": "string"
                        },
                        "number_of_pets": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "number_of_pets_notes": {
                            "title": "Number Of Pets Notes",
                            "type": "string"
                        },
                        "ota_confirmation_code": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "ota_confirmation_code_notes": {
                            "title": "Ota Confirmation Code Notes",
                            "type": "string"
                        },
                        "payment_status": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "payment_status_notes": {
                            "title": "Payment Status Notes",
                            "type": "string"
                        },
                        "status": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "status_notes": {
                            "title": "Status Notes",
                            "type": "string"
                        },
                        "tags": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "tags_notes": {
                            "title": "Tags Notes",
                            "type": "string"
                        },
                        "taxes": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "taxes_notes": {
                            "title": "Taxes Notes",
                            "type": "string"
                        },
                        "total_guest_paid": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "total_guest_paid_notes": {
                            "title": "Total Guest Paid Notes",
                            "type": "string"
                        },
                        "enso_guest_data": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "enso_guest_data_notes": {
                            "title": "Enso Guest Data Notes",
                            "type": "string"
                        },
                        "enso_upsell_financial_data": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "enso_upsell_financial_data_notes": {
                            "title": "Enso Upsell Financial Data Notes",
                            "type": "string"
                        },
                        "enso_fees_financial_data": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "enso_fees_financial_data_notes": {
                            "title": "Enso Fees Financial Data Notes",
                            "type": "string"
                        },
                        "enso_boarding_pass_link": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "enso_boarding_pass_link_notes": {
                            "title": "Enso Boarding Pass Link Notes",
                            "type": "string"
                        },
                        "custom_fields": {
                            "title": "Custom Fields",
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "all_custom_fields": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "custom_fields_notes": {
                            "title": "Custom Fields Notes",
                            "type": "string"
                        },
                        "dual_sync_fields": {
                            "title": "Dual Sync Fields",
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "dual_sync_notes": {
                            "title": "Dual Sync Notes",
                            "type": "string"
                        }
                    },
                    "required": [
                        "booking_multi_guest_support",
                        "checkin_date",
                        "checkin_time",
                        "checkout_date",
                        "checkout_time",
                        "currency",
                        "device_codes",
                        "fees",
                        "guest_country",
                        "guest_email",
                        "guest_phone",
                        "guest_language",
                        "host_payout_amount",
                        "inquiries",
                        "nightly_rate",
                        "number_of_adults",
                        "number_of_children",
                        "number_of_pets",
                        "ota_confirmation_code",
                        "payment_status",
                        "status",
                        "tags",
                        "taxes",
                        "total_guest_paid",
                        "enso_guest_data",
                        "enso_upsell_financial_data",
                        "enso_fees_financial_data",
                        "enso_boarding_pass_link",
                        "custom_fields",
                        "all_custom_fields",
                        "dual_sync_fields"
                    ]
                },
                "ListingFieldsSpecModel": {
                    "title": "ListingFieldsSpecModel",
                    "type": "object",
                    "properties": {
                        "listing_multi_unit_support": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "listing_multi_unit_support_notes": {
                            "title": "Listing Multi Unit Support Notes",
                            "type": "string"
                        },
                        "active_inactive": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "active_inactive_notes": {
                            "title": "Active Inactive Notes",
                            "type": "string"
                        },
                        "amenities": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "amenities_notes": {
                            "title": "Amenities Notes",
                            "type": "string"
                        },
                        "availability": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "availability_notes": {
                            "title": "Availability Notes",
                            "type": "string"
                        },
                        "checkin_directions": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "checkin_directions_notes": {
                            "title": "Checkin Directions Notes",
                            "type": "string"
                        },
                        "checkin_out_times": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "checkin_out_times_notes": {
                            "title": "Checkin Out Times Notes",
                            "type": "string"
                        },
                        "complete_address": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "complete_address_notes": {
                            "title": "Complete Address Notes",
                            "type": "string"
                        },
                        "currency": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "currency_notes": {
                            "title": "Currency Notes",
                            "type": "string"
                        },
                        "description": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "description_notes": {
                            "title": "Description Notes",
                            "type": "string"
                        },
                        "house_rules": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "house_rules_notes": {
                            "title": "House Rules Notes",
                            "type": "string"
                        },
                        "max_guests": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "max_guests_notes": {
                            "title": "Max Guests Notes",
                            "type": "string"
                        },
                        "max_children": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "max_children_notes": {
                            "title": "Max Children Notes",
                            "type": "string"
                        },
                        "name": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "name_notes": {
                            "title": "Name Notes",
                            "type": "string"
                        },
                        "nickname": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "nickname_notes": {
                            "title": "Nickname Notes",
                            "type": "string"
                        },
                        "pet_policy": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "pet_policy_notes": {
                            "title": "Pet Policy Notes",
                            "type": "string"
                        },
                        "smoking_policy": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "smoking_policy_notes": {
                            "title": "Smoking Policy Notes",
                            "type": "string"
                        },
                        "picture": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "picture_notes": {
                            "title": "Picture Notes",
                            "type": "string"
                        },
                        "pictures": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "pictures_notes": {
                            "title": "Pictures Notes",
                            "type": "string"
                        },
                        "property_type": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "property_type_notes": {
                            "title": "Property Type Notes",
                            "type": "string"
                        },
                        "rooms": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "rooms_notes": {
                            "title": "Rooms Notes",
                            "type": "string"
                        },
                        "space": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "space_notes": {
                            "title": "Space Notes",
                            "type": "string"
                        },
                        "tags": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "tags_notes": {
                            "title": "Tags Notes",
                            "type": "string"
                        },
                        "wifi_info": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "wifi_info_notes": {
                            "title": "Wifi Info Notes",
                            "type": "string"
                        },
                        "custom_fields": {
                            "title": "Custom Fields",
                            "default": [],
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "all_custom_fields": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "custom_fields_notes": {
                            "title": "Custom Fields Notes",
                            "type": "string"
                        },
                        "dual_sync_fields": {
                            "title": "Dual Sync Fields",
                            "default": [],
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "dual_sync_notes": {
                            "title": "Dual Sync Notes",
                            "type": "string"
                        },
                        "pre_approval_channels": {
                            "title": "Pre Approval Channels",
                            "type": "string"
                        }
                    },
                    "required": [
                        "listing_multi_unit_support",
                        "active_inactive",
                        "amenities",
                        "availability",
                        "checkin_directions",
                        "checkin_out_times",
                        "complete_address",
                        "currency",
                        "description",
                        "house_rules",
                        "max_guests",
                        "max_children",
                        "name",
                        "nickname",
                        "pet_policy",
                        "smoking_policy",
                        "picture",
                        "pictures",
                        "property_type",
                        "rooms",
                        "space",
                        "tags",
                        "wifi_info",
                        "all_custom_fields"
                    ]
                },
                "MessageFieldsSpecModel": {
                    "title": "MessageFieldsSpecModel",
                    "type": "object",
                    "properties": {
                        "message_attachments_notes": {
                            "title": "Message Attachments Notes",
                            "type": "string"
                        },
                        "message_attachments_functionality_notes": {
                            "title": "Message Attachments Functionality Notes",
                            "type": "string"
                        },
                        "view_message_channels": {
                            "title": "View Message Channels",
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "view_message_channels_notes": {
                            "title": "View Message Channels Notes",
                            "type": "string"
                        },
                        "message_dual_sync_notes": {
                            "title": "Message Dual Sync Notes",
                            "type": "string"
                        },
                        "message_dual_notes": {
                            "title": "Message Dual Notes",
                            "type": "string"
                        },
                        "pre_approval_support": {
                            "title": "Pre Approval Support",
                            "type": "string"
                        },
                        "pre_approval_notes": {
                            "title": "Pre Approval Notes",
                            "type": "string"
                        }
                    },
                    "required": [
                        "view_message_channels"
                    ]
                },
                "MessageChannelTypeEnum": {
                    "title": "MessageChannelTypeEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "SMS",
                        "email",
                        "airbnb",
                        "whatsapp",
                        "automessage",
                        "note",
                        "internal",
                        "vrbo",
                        "homeaway",
                        "booking_com",
                        "expedia"
                    ],
                    "type": "string"
                },
                "MessagingSupportModel": {
                    "title": "MessagingSupportModel",
                    "type": "object",
                    "properties": {
                        "channel": {
                            "$ref": "#/definitions/MessageChannelTypeEnum"
                        },
                        "channel_notes": {
                            "title": "Channel Notes",
                            "type": "string"
                        },
                        "receiving": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "receiving_notes": {
                            "title": "Receiving Notes",
                            "type": "string"
                        },
                        "ota": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "ota_notes": {
                            "title": "Ota Notes",
                            "type": "string"
                        },
                        "syncing": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "syncing_notes": {
                            "title": "Syncing Notes",
                            "type": "string"
                        },
                        "attachments": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "attachments_notes": {
                            "title": "Attachments Notes",
                            "type": "string"
                        },
                        "caveats": {
                            "title": "Caveats",
                            "type": "string"
                        }
                    },
                    "required": [
                        "channel",
                        "receiving",
                        "ota",
                        "syncing",
                        "attachments"
                    ]
                },
                "ChannelTypeEnum": {
                    "title": "ChannelTypeEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "Airbnb",
                        "VRBO",
                        "Expedia",
                        "Abritel",
                        "Agoda",
                        "Atraveo",
                        "Best Fewo",
                        "Booking.com",
                        "Casamundo",
                        "E-Domizil",
                        "Flipkey",
                        "Google",
                        "Holiday Lettings",
                        "Happy Stay",
                        "Rentals United",
                        "Home Away",
                        "Veepee",
                        "Simplissimmo",
                        "Hotel Tonight",
                        "Facebook Messenger",
                        "NineFlats",
                        "Trip Advisor",
                        "Direct Booking",
                        "other"
                    ],
                    "type": "string"
                },
                "InquiryFieldsSpecModel": {
                    "title": "InquiryFieldsSpecModel",
                    "type": "object",
                    "properties": {
                        "channel": {
                            "$ref": "#/definitions/ChannelTypeEnum"
                        },
                        "channel_notes": {
                            "title": "Channel Notes",
                            "type": "string"
                        },
                        "supported": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "supported_notes": {
                            "title": "Supported Notes",
                            "type": "string"
                        },
                        "inquiry_message_included": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "inquiry_message_included_notes": {
                            "title": "Inquiry Message Included Notes",
                            "type": "string"
                        },
                        "payment_information": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "payment_information_notes": {
                            "title": "Payment Information Notes",
                            "type": "string"
                        },
                        "pre_approve_in_enso": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "pre_approve_in_enso_notes": {
                            "title": "Pre Approve In Enso Notes",
                            "type": "string"
                        },
                        "caveats": {
                            "title": "Caveats",
                            "type": "string"
                        }
                    },
                    "required": [
                        "channel",
                        "supported"
                    ]
                },
                "PendingBookingsSpecModel": {
                    "title": "PendingBookingsSpecModel",
                    "type": "object",
                    "properties": {
                        "channel": {
                            "$ref": "#/definitions/ChannelTypeEnum"
                        },
                        "channel_notes": {
                            "title": "Channel Notes",
                            "type": "string"
                        },
                        "supported": {
                            "$ref": "#/definitions/FeatureSupportEnum"
                        },
                        "supported_notes": {
                            "title": "Supported Notes",
                            "type": "string"
                        },
                        "caveats": {
                            "title": "Caveats",
                            "type": "string"
                        }
                    },
                    "required": [
                        "channel",
                        "supported"
                    ]
                },
                "PMSFormProperties": {
                    "title": "PMSFormProperties",
                    "type": "object",
                    "properties": {
                        "listing_sync_frequency": {
                            "title": "Listing Sync Frequency",
                            "enum": [
                                "24 hr",
                                "<2 min"
                            ],
                            "type": "string"
                        },
                        "booking_sync_frequency": {
                            "title": "Booking Sync Frequency",
                            "enum": [
                                "5 min",
                                "<2 min"
                            ],
                            "type": "string"
                        },
                        "message_sync_frequency": {
                            "title": "Message Sync Frequency",
                            "enum": [
                                "none",
                                "<2 min",
                                "5 min"
                            ],
                            "type": "string"
                        },
                        "booking_fields_spec": {
                            "$ref": "#/definitions/BookingFieldsSpecModel"
                        },
                        "booking_push_fields_spec": {
                            "$ref": "#/definitions/BookingPushFieldsSpecModel"
                        },
                        "listing_fields_spec": {
                            "$ref": "#/definitions/ListingFieldsSpecModel"
                        },
                        "message_fields_spec": {
                            "$ref": "#/definitions/MessageFieldsSpecModel"
                        },
                        "messaging_support_spec": {
                            "title": "Messaging Support Spec",
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/MessagingSupportModel"
                            }
                        },
                        "inquiry_fields_spec": {
                            "title": "Inquiry Fields Spec",
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/InquiryFieldsSpecModel"
                            }
                        },
                        "pending_bookings_spec": {
                            "title": "Pending Bookings Spec",
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/PendingBookingsSpecModel"
                            }
                        },
                        "api_docs": {
                            "title": "Api Docs",
                            "type": "string"
                        },
                        "next_step": {
                            "title": "Next Step",
                            "type": "string"
                        }
                    },
                    "required": [
                        "listing_sync_frequency",
                        "booking_sync_frequency",
                        "message_sync_frequency",
                        "booking_fields_spec",
                        "booking_push_fields_spec",
                        "listing_fields_spec",
                        "message_fields_spec",
                        "messaging_support_spec",
                        "inquiry_fields_spec",
                        "pending_bookings_spec"
                    ]
                }
            }
        },
        "columns": [
            {
                "field": "title",
                "headerName": "Name",
                "width": 200
            },
            {
                "field": "icon",
                "headerName": "Icon",
                "width": 200,
                "type": "icon"
            },
            {
                "field": "service",
                "headerName": "Service",
                "width": 200
            },
            {
                "field": "provider",
                "headerName": "Provider",
                "width": 200
            }
        ]
    },
    {
        "title": "Guidebooks",
        "subtitle": "Curate your guides",
        "content_type": "guidebook",
        "form_schema": {
            "title": "GuidebookTemplateModel",
            "type": "object",
            "properties": {
                "title": {
                    "title": "Title",
                    "type": "string"
                },
                "icon_url": {
                    "title": "Icon Url",
                    "type": "string"
                },
                "picture_url": {
                    "title": "Picture Url",
                    "type": "string"
                },
                "how_it_works": {
                    "title": "How It Works",
                    "type": "string"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "enabled": {
                    "title": "Enabled",
                    "type": "boolean"
                },
                "launchdarkly_feature_flag_key": {
                    "title": "Launchdarkly Feature Flag Key",
                    "type": "string"
                },
                "content": {
                    "$ref": "#/definitions/GuidebookModel"
                },
                "ai_prompt": {
                    "title": "Ai Prompt",
                    "type": "string"
                },
                "google_place_queries": {
                    "title": "Google Place Queries",
                    "default": [],
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/GooglePlaceQueryModel"
                    }
                }
            },
            "required": [
                "content"
            ],
            "definitions": {
                "LanguageEnum": {
                    "title": "LanguageEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "ab",
                        "aa",
                        "af",
                        "ak",
                        "sq",
                        "am",
                        "ar",
                        "hy",
                        "ay",
                        "az",
                        "bm",
                        "ba",
                        "eu",
                        "be",
                        "bn",
                        "bh",
                        "bi",
                        "bs",
                        "br",
                        "bg",
                        "my",
                        "ca",
                        "ch",
                        "ce",
                        "zh",
                        "cv",
                        "kw",
                        "co",
                        "cr",
                        "hr",
                        "cs",
                        "da",
                        "dv",
                        "nl",
                        "dz",
                        "en",
                        "eo",
                        "et",
                        "ee",
                        "fo",
                        "fj",
                        "fi",
                        "fr",
                        "ff",
                        "gl",
                        "ka",
                        "de",
                        "el",
                        "gn",
                        "gu",
                        "ht",
                        "ha",
                        "he",
                        "hz",
                        "hi",
                        "hu",
                        "id",
                        "ga",
                        "ig",
                        "ik",
                        "io",
                        "is",
                        "it",
                        "iu",
                        "ja",
                        "jv",
                        "kl",
                        "kn",
                        "kr",
                        "ks",
                        "kk",
                        "km",
                        "ki",
                        "rw",
                        "ky",
                        "kv",
                        "kg",
                        "ko",
                        "ku",
                        "kj",
                        "lb",
                        "lg",
                        "li",
                        "ln",
                        "lo",
                        "lt",
                        "lu",
                        "lv",
                        "gv",
                        "mk",
                        "mg",
                        "ms",
                        "ml",
                        "mt",
                        "mi",
                        "mr",
                        "mh",
                        "mn",
                        "na",
                        "nv",
                        "nd",
                        "ne",
                        "nb",
                        "no",
                        "ii",
                        "nr",
                        "oc",
                        "oj",
                        "cu",
                        "om",
                        "or",
                        "os",
                        "pa",
                        "pi",
                        "fa",
                        "pl",
                        "pt",
                        "qu",
                        "rm",
                        "rn",
                        "ro",
                        "ru",
                        "sa",
                        "sd",
                        "se",
                        "sm",
                        "sg",
                        "sr",
                        "gd",
                        "sn",
                        "si",
                        "sk",
                        "sl",
                        "so",
                        "st",
                        "es",
                        "su",
                        "sw",
                        "ss",
                        "sv",
                        "ta",
                        "te",
                        "tg",
                        "th",
                        "ti",
                        "bo",
                        "tk",
                        "tl",
                        "tn",
                        "to",
                        "tr",
                        "tt",
                        "tw",
                        "ty",
                        "ug",
                        "uk",
                        "ur",
                        "uz",
                        "ve",
                        "vi",
                        "wa",
                        "cy",
                        "wo",
                        "fy",
                        "xh",
                        "yi",
                        "yo",
                        "za",
                        "zu"
                    ],
                    "type": "string"
                },
                "LanguageTextModel": {
                    "title": "LanguageTextModel",
                    "type": "object",
                    "properties": {
                        "language": {
                            "$ref": "#/definitions/LanguageEnum"
                        },
                        "value": {
                            "title": "Value",
                            "type": "string"
                        }
                    },
                    "required": [
                        "language",
                        "value"
                    ]
                },
                "GuidebookPageModel": {
                    "title": "GuidebookPageModel",
                    "type": "object",
                    "properties": {
                        "name": {
                            "title": "Name",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        },
                        "images": {
                            "title": "Images",
                            "default": [],
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "text": {
                            "title": "Text",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        }
                    }
                },
                "AddressModel": {
                    "title": "AddressModel",
                    "type": "object",
                    "properties": {
                        "apt_number": {
                            "title": "Apt Number",
                            "type": "string"
                        },
                        "street": {
                            "title": "Street",
                            "type": "string"
                        },
                        "city": {
                            "title": "City",
                            "type": "string"
                        },
                        "state": {
                            "title": "State",
                            "type": "string"
                        },
                        "country": {
                            "title": "Country",
                            "type": "string"
                        },
                        "zip_code": {
                            "title": "Zip Code",
                            "type": "string"
                        },
                        "lat": {
                            "title": "Lat",
                            "type": "string"
                        },
                        "lng": {
                            "title": "Lng",
                            "type": "string"
                        },
                        "timezone": {
                            "title": "Timezone",
                            "type": "number"
                        },
                        "timezone_string": {
                            "title": "Timezone String",
                            "type": "string"
                        },
                        "formatted": {
                            "title": "Formatted",
                            "type": "string"
                        }
                    }
                },
                "Review": {
                    "title": "Review",
                    "type": "object",
                    "properties": {
                        "author_name": {
                            "title": "Author Name",
                            "type": "string"
                        },
                        "author_url": {
                            "title": "Author Url",
                            "minLength": 1,
                            "maxLength": 2083,
                            "format": "uri",
                            "type": "string"
                        },
                        "language": {
                            "title": "Language",
                            "type": "string"
                        },
                        "profile_photo_url": {
                            "title": "Profile Photo Url",
                            "minLength": 1,
                            "maxLength": 2083,
                            "format": "uri",
                            "type": "string"
                        },
                        "rating": {
                            "title": "Rating",
                            "type": "number"
                        },
                        "relative_time_description": {
                            "title": "Relative Time Description",
                            "type": "string"
                        },
                        "text": {
                            "title": "Text",
                            "type": "string"
                        },
                        "time": {
                            "title": "Time",
                            "type": "integer"
                        }
                    },
                    "required": [
                        "author_name"
                    ]
                },
                "PlaceComponent": {
                    "title": "PlaceComponent",
                    "type": "object",
                    "properties": {
                        "id": {
                            "title": "Id",
                            "type": "string"
                        },
                        "type": {
                            "title": "Type",
                            "default": "place",
                            "enum": [
                                "place"
                            ],
                            "type": "string"
                        },
                        "address": {
                            "$ref": "#/definitions/AddressModel"
                        },
                        "image": {
                            "title": "Image",
                            "minLength": 1,
                            "maxLength": 2083,
                            "format": "uri",
                            "type": "string"
                        },
                        "rating": {
                            "title": "Rating",
                            "type": "number"
                        },
                        "website": {
                            "title": "Website",
                            "minLength": 1,
                            "maxLength": 2083,
                            "format": "uri",
                            "type": "string"
                        },
                        "place_type": {
                            "title": "Place Type",
                            "type": "string"
                        },
                        "directions_link": {
                            "title": "Directions Link",
                            "type": "string"
                        },
                        "display_name": {
                            "title": "Display Name",
                            "type": "string"
                        },
                        "reviews": {
                            "title": "Reviews",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/Review"
                            }
                        },
                        "star_rating": {
                            "title": "Star Rating",
                            "type": "number"
                        },
                        "text": {
                            "title": "Text",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        },
                        "header": {
                            "title": "Header",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        }
                    },
                    "required": [
                        "id"
                    ]
                },
                "SummaryComponent": {
                    "title": "SummaryComponent",
                    "type": "object",
                    "properties": {
                        "id": {
                            "title": "Id",
                            "type": "string"
                        },
                        "type": {
                            "title": "Type",
                            "default": "summary",
                            "enum": [
                                "summary"
                            ],
                            "type": "string"
                        },
                        "text": {
                            "title": "Text",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        },
                        "show_contents": {
                            "title": "Show Contents",
                            "default": false,
                            "type": "boolean"
                        },
                        "collapse_after_pixels": {
                            "title": "Collapse After Pixels",
                            "type": "integer"
                        }
                    },
                    "required": [
                        "id"
                    ]
                },
                "HeaderComponent": {
                    "title": "HeaderComponent",
                    "type": "object",
                    "properties": {
                        "id": {
                            "title": "Id",
                            "type": "string"
                        },
                        "type": {
                            "title": "Type",
                            "default": "header",
                            "enum": [
                                "header"
                            ],
                            "type": "string"
                        },
                        "icon": {
                            "title": "Icon",
                            "type": "string"
                        },
                        "text": {
                            "title": "Text",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        },
                        "label": {
                            "title": "Label",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        }
                    },
                    "required": [
                        "id"
                    ]
                },
                "ListStyleEnum": {
                    "title": "ListStyleEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "divided",
                        "numbered",
                        "bulleted"
                    ],
                    "type": "string"
                },
                "ListItem": {
                    "title": "ListItem",
                    "type": "object",
                    "properties": {
                        "primary_text": {
                            "title": "Primary Text",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        },
                        "secondary_text": {
                            "title": "Secondary Text",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        }
                    }
                },
                "ListComponent": {
                    "title": "ListComponent",
                    "type": "object",
                    "properties": {
                        "id": {
                            "title": "Id",
                            "type": "string"
                        },
                        "type": {
                            "title": "Type",
                            "default": "list",
                            "enum": [
                                "list"
                            ],
                            "type": "string"
                        },
                        "text": {
                            "title": "Text",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        },
                        "list_style": {
                            "default": "divided",
                            "allOf": [
                                {
                                    "$ref": "#/definitions/ListStyleEnum"
                                }
                            ]
                        },
                        "list_items": {
                            "title": "List Items",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/ListItem"
                            }
                        },
                        "collapsable": {
                            "title": "Collapsable",
                            "default": false,
                            "type": "boolean"
                        }
                    },
                    "required": [
                        "id"
                    ]
                },
                "TextComponent": {
                    "title": "TextComponent",
                    "type": "object",
                    "properties": {
                        "id": {
                            "title": "Id",
                            "type": "string"
                        },
                        "type": {
                            "title": "Type",
                            "default": "text",
                            "enum": [
                                "text"
                            ],
                            "type": "string"
                        },
                        "text": {
                            "title": "Text",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        },
                        "collapse_after_pixels": {
                            "title": "Collapse After Pixels",
                            "type": "integer"
                        }
                    },
                    "required": [
                        "id"
                    ]
                },
                "ButtonTypeEnum": {
                    "title": "ButtonTypeEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "external_link",
                        "boarding_pass_guidebook",
                        "boarding_pass_upsell"
                    ],
                    "type": "string"
                },
                "ButtonComponent": {
                    "title": "ButtonComponent",
                    "type": "object",
                    "properties": {
                        "id": {
                            "title": "Id",
                            "type": "string"
                        },
                        "type": {
                            "title": "Type",
                            "default": "button",
                            "enum": [
                                "button"
                            ],
                            "type": "string"
                        },
                        "text": {
                            "title": "Text",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        },
                        "button_url": {
                            "title": "Button Url",
                            "type": "string"
                        },
                        "button_type": {
                            "$ref": "#/definitions/ButtonTypeEnum"
                        },
                        "redirect_resource_id": {
                            "title": "Redirect Resource Id",
                            "type": "string"
                        },
                        "redirect_resource_type": {
                            "title": "Redirect Resource Type",
                            "type": "string"
                        }
                    },
                    "required": [
                        "id",
                        "button_type"
                    ]
                },
                "ImageComponent": {
                    "title": "ImageComponent",
                    "type": "object",
                    "properties": {
                        "id": {
                            "title": "Id",
                            "type": "string"
                        },
                        "type": {
                            "title": "Type",
                            "default": "image",
                            "enum": [
                                "image"
                            ],
                            "type": "string"
                        },
                        "text": {
                            "title": "Text",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/LanguageTextModel"
                            }
                        },
                        "image": {
                            "title": "Image",
                            "type": "array",
                            "items": {
                                "type": "string",
                                "minLength": 1,
                                "maxLength": 2083,
                                "format": "uri"
                            }
                        },
                        "image_display_type": {
                            "title": "Image Display Type",
                            "default": "cropped",
                            "type": "string"
                        }
                    },
                    "required": [
                        "id"
                    ]
                },
                "FieldEnum": {
                    "title": "FieldEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "device_id",
                        "notification_type",
                        "notification_enso_user_id",
                        "sent",
                        "booking_post_stay_gap",
                        "booking_pre_stay_gap",
                        "booking_star_rating",
                        "booking_created_at",
                        "booking_action",
                        "booking_channel",
                        "booking_status",
                        "booking_payout",
                        "booking_payout_and_fees",
                        "total_guest_paid",
                        "booking_payment_currency",
                        "booking_payment_status",
                        "booking_payment_amount_remaining",
                        "booking_nightly_rate",
                        "booking_listing",
                        "booking_listing_name",
                        "booking_guest_name",
                        "booking_tags",
                        "guest_verification_status",
                        "guest_booking_tags",
                        "booking_checkin_dt",
                        "booking_checkout_dt",
                        "booking_lead_time",
                        "time_until_checkin",
                        "time_until_checkout",
                        "booking_purchased_upsells",
                        "booking_purchased_fees",
                        "booking_expected_checkin_time",
                        "booking_expected_checkout_time",
                        "checkin_date",
                        "checkout_date",
                        "checkin_time",
                        "checkout_time",
                        "booking_id",
                        "booking_ota_confirmation_code",
                        "integration_booking_id",
                        "booking_integration",
                        "keycard_link",
                        "keycard_code",
                        "total_people_booked",
                        "total_rev",
                        "num_nights",
                        "num_adult",
                        "num_child",
                        "num_pets",
                        "booking_listing_group_id",
                        "month",
                        "current_date",
                        "time_of_day",
                        "guest_group_id",
                        "guest_updated_at",
                        "guest_integration",
                        "guest_stage",
                        "guest_bookings",
                        "rating",
                        "guest_inquiry",
                        "guest_id",
                        "guest_language",
                        "guest_channel",
                        "guest_destination",
                        "guest_listing",
                        "guest_country",
                        "guest_location",
                        "guest_status",
                        "guest_dob",
                        "guest_age",
                        "guest_email",
                        "guest_travel_reason",
                        "guest_address",
                        "guest_first_name",
                        "guest_last_name",
                        "traveler_input",
                        "guest_tags",
                        "guest_followers",
                        "guest_following",
                        "guest_name",
                        "ota_confirmation_codes",
                        "guest_phone",
                        "reply_phone",
                        "assigned_to",
                        "unanswered_messages",
                        "unread_messages",
                        "guest_type",
                        "guest_ai_summary",
                        "guest_checkin_date",
                        "guest_checkout_date",
                        "guest_local_checkin_date",
                        "guest_local_checkout_date",
                        "guest_booking_actions",
                        "guest_purchased_product_types",
                        "guest_purchased_product_names",
                        "enso_total_revenue",
                        "conversation_stage",
                        "guest_boarding_pass_engagement",
                        "guest_boarding_pass_overrides",
                        "guest_safety_deposits",
                        "guest_bill_title",
                        "guest_bill_total",
                        "guest_bill_session_id",
                        "guest_bill_created_at",
                        "guest_bill_updated_at",
                        "guest_bill_booking_id",
                        "guest_bill_listing_group_id",
                        "guest_bill_listing_resource",
                        "guest_bill_product_type",
                        "guest_bill_currency",
                        "guest_bill_status",
                        "message_channel",
                        "message_sent_at",
                        "message_sender",
                        "message_topics",
                        "message_sender_enso_user_id",
                        "message_delivery_state",
                        "guest_selfie",
                        "guest_govt_id_front",
                        "guest_govt_id_back",
                        "guest_other_id",
                        "deposit",
                        "fee",
                        "pet_fee",
                        "listing_id",
                        "listing_checkin_time",
                        "listing_checkout_time",
                        "listing_type",
                        "listing_channels",
                        "listing_active",
                        "listing_name",
                        "listing_nickname",
                        "listing_address",
                        "listing_currency",
                        "listing_longitude",
                        "listing_latitude",
                        "listing_state",
                        "listing_city",
                        "listing_photo",
                        "listing_street",
                        "listing_apt_number",
                        "country",
                        "listing_rules",
                        "listing_description",
                        "listing_short_description",
                        "listing_transport",
                        "listing_guest_notes",
                        "listing_names",
                        "listing_num_bathrooms",
                        "listing_num_bedrooms",
                        "listing_tags",
                        "listing_group_id",
                        "listing_errors",
                        "kb_completion_percentage",
                        "kb_completed_categories",
                        "ai_suggestions_count",
                        "checkin_directions",
                        "checkout_directions",
                        "smoking_policy",
                        "max_kids",
                        "max_adults",
                        "zip_code",
                        "wifi_network",
                        "wifi_password",
                        "pet_policy",
                        "sort_id",
                        "branding_logo",
                        "listing_keycard_link",
                        "question_type",
                        "lock_access_code",
                        "message",
                        "sent_at",
                        "delivered",
                        "payment",
                        "checkin_raw",
                        "checkout_raw",
                        "response_time",
                        "num_messages",
                        "sentiment",
                        "attachments",
                        "notification_message",
                        "viewed",
                        "is_error",
                        "device_trigger",
                        "num_listings",
                        "message_stage_tags",
                        "messages_guest_id",
                        "device_name",
                        "start",
                        "page",
                        "autohost_bgcheck_confirmation",
                        "guest_dob_dt",
                        "wifi",
                        "amenities",
                        "description",
                        "guest_notes",
                        "transport",
                        "policies"
                    ],
                    "type": "string"
                },
                "BooleanOperatorEnum": {
                    "title": "BooleanOperatorEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "one_of",
                        "in",
                        "nin",
                        "==",
                        "!=",
                        ">",
                        ">=",
                        "<",
                        "<=",
                        "?",
                        "!",
                        "not_begins_with"
                    ],
                    "type": "string"
                },
                "FieldTypeEnum": {
                    "title": "FieldTypeEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "checkbox",
                        "text",
                        "single_select",
                        "multi_select",
                        "number",
                        "image",
                        "date",
                        "time",
                        "time_offset",
                        "traveler_input",
                        "country",
                        "range",
                        "local_date",
                        "custom"
                    ],
                    "type": "string"
                },
                "BooleanCondition": {
                    "title": "BooleanCondition",
                    "description": "Limits the trigger to only trigger if an enso object has a\ncertain property (only for use by developers)",
                    "type": "object",
                    "properties": {
                        "c_type": {
                            "title": "C Type",
                            "default": "bool",
                            "type": "string"
                        },
                        "field": {
                            "title": "Field",
                            "anyOf": [
                                {
                                    "$ref": "#/definitions/FieldEnum"
                                },
                                {
                                    "type": "string"
                                }
                            ]
                        },
                        "operator": {
                            "default": "==",
                            "allOf": [
                                {
                                    "$ref": "#/definitions/BooleanOperatorEnum"
                                }
                            ]
                        },
                        "field_type": {
                            "default": "text",
                            "allOf": [
                                {
                                    "$ref": "#/definitions/FieldTypeEnum"
                                }
                            ]
                        },
                        "val": {
                            "title": "Val"
                        }
                    },
                    "required": [
                        "field"
                    ]
                },
                "GuidebookModel": {
                    "title": "GuidebookModel",
                    "type": "object",
                    "properties": {
                        "guidebook_id": {
                            "title": "Guidebook Id",
                            "type": "string"
                        },
                        "main_page": {
                            "$ref": "#/definitions/GuidebookPageModel"
                        },
                        "pages": {
                            "title": "Pages",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/GuidebookPageModel"
                            }
                        },
                        "components": {
                            "title": "Components",
                            "default": [],
                            "type": "array",
                            "items": {
                                "anyOf": [
                                    {
                                        "$ref": "#/definitions/PlaceComponent"
                                    },
                                    {
                                        "$ref": "#/definitions/SummaryComponent"
                                    },
                                    {
                                        "$ref": "#/definitions/HeaderComponent"
                                    },
                                    {
                                        "$ref": "#/definitions/ListComponent"
                                    },
                                    {
                                        "$ref": "#/definitions/TextComponent"
                                    },
                                    {
                                        "$ref": "#/definitions/ButtonComponent"
                                    },
                                    {
                                        "$ref": "#/definitions/ImageComponent"
                                    }
                                ]
                            }
                        },
                        "conditions": {
                            "title": "Conditions",
                            "default": [],
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/BooleanCondition"
                            }
                        },
                        "header_image": {
                            "title": "Header Image",
                            "type": "string"
                        },
                        "preview_text": {
                            "title": "Preview Text",
                            "type": "string"
                        }
                    },
                    "required": [
                        "main_page"
                    ]
                },
                "GooglePlaceQueryModel": {
                    "title": "GooglePlaceQueryModel",
                    "type": "object",
                    "properties": {
                        "query": {
                            "title": "Query",
                            "type": "string"
                        },
                        "num_items": {
                            "title": "Num Items",
                            "type": "integer"
                        }
                    },
                    "required": [
                        "query",
                        "num_items"
                    ]
                }
            }
        },
        "columns": [
            {
                "field": "title",
                "headerName": "Name",
                "width": 200
            }
        ]
    },
    {
        "title": "Upsells",
        "subtitle": "Increase your revenue",
        "content_type": "upsell",
        "form_schema": {
            "title": "UpsellTemplateModel",
            "type": "object",
            "properties": {
                "title": {
                    "title": "Title",
                    "type": "string"
                },
                "icon_url": {
                    "title": "Icon Url",
                    "type": "string"
                },
                "picture_url": {
                    "title": "Picture Url",
                    "type": "string"
                },
                "how_it_works": {
                    "title": "How It Works",
                    "type": "string"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "enabled": {
                    "title": "Enabled",
                    "type": "boolean"
                },
                "launchdarkly_feature_flag_key": {
                    "title": "Launchdarkly Feature Flag Key",
                    "type": "string"
                },
                "content": {
                    "title": "Content",
                    "type": "object"
                }
            },
            "required": [
                "content"
            ]
        },
        "columns": [
            {
                "field": "title",
                "headerName": "Name",
                "width": 200
            },
            {
                "field": "description",
                "headerName": "Description",
                "width": 200
            }
        ]
    },
    {
        "title": "Fees",
        "subtitle": "Setup additional fees",
        "content_type": "fee",
        "form_schema": {
            "title": "TemplateModel",
            "type": "object",
            "properties": {
                "title": {
                    "title": "Title",
                    "type": "string"
                },
                "icon_url": {
                    "title": "Icon Url",
                    "type": "string"
                },
                "picture_url": {
                    "title": "Picture Url",
                    "type": "string"
                },
                "how_it_works": {
                    "title": "How It Works",
                    "type": "string"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "enabled": {
                    "title": "Enabled",
                    "type": "boolean"
                },
                "launchdarkly_feature_flag_key": {
                    "title": "Launchdarkly Feature Flag Key",
                    "type": "string"
                }
            }
        },
        "columns": [
            {
                "field": "title",
                "headerName": "Name",
                "width": 200
            },
            {
                "field": "description",
                "headerName": "Description",
                "width": 200
            }
        ]
    },
    {
        "title": "Local Services",
        "subtitle": "Explore local offerings",
        "content_type": "local_service",
        "form_schema": {
            "title": "LocalServiceModel",
            "type": "object",
            "properties": {
                "id": {
                    "title": "Id",
                    "type": "string"
                },
                "name": {
                    "title": "Name",
                    "type": "string"
                },
                "url": {
                    "title": "Url",
                    "type": "string"
                },
                "enabled": {
                    "title": "Enabled",
                    "default": true,
                    "type": "boolean"
                },
                "category": {
                    "$ref": "#/definitions/LocalServiceTypeEnum"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "launchdarkly_feature_flag_key": {
                    "title": "Launchdarkly Feature Flag Key",
                    "type": "string"
                }
            },
            "required": [
                "id",
                "category"
            ],
            "definitions": {
                "LocalServiceTypeEnum": {
                    "title": "LocalServiceTypeEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "transportation",
                        "luggage",
                        "food_and_beverage",
                        "experiences",
                        "guidebooks",
                        "healthcare",
                        "other",
                        "car_rentals",
                        "airlines",
                        "tickets",
                        "groceries",
                        "laundry",
                        "guides",
                        "gifts",
                        "infants_and_children",
                        "flowers",
                        "activity_equipment",
                        "classes",
                        "shopping"
                    ],
                    "type": "string"
                }
            }
        },
        "columns": [
            {
                "field": "id",
                "headerName": "Icon",
                "width": 200,
                "type": "upsell_icon"
            },
            {
                "field": "name",
                "headerName": "Name",
                "width": 200
            },
            {
                "field": "enabled",
                "headerName": "Enabled",
                "width": 200
            },
            {
                "field": "category",
                "headerName": "Category",
                "width": 200
            }
        ]
    },
    {
        "title": "Images",
        "subtitle": "Manage your images",
        "content_type": "image",
        "form_schema": {
            "title": "PresetImageModel",
            "type": "object",
            "properties": {
                "image_url": {
                    "title": "Image Url",
                    "type": "string"
                },
                "tags": {
                    "title": "Tags",
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "resource_types": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/ListingResourceEnum"
                    }
                }
            },
            "required": [
                "image_url",
                "tags",
                "resource_types"
            ],
            "definitions": {
                "ListingResourceEnum": {
                    "title": "ListingResourceEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "gb",
                        "ci",
                        "co",
                        "up",
                        "fee",
                        "cv",
                        "rp",
                        "py",
                        "bd",
                        "sop"
                    ],
                    "type": "string"
                }
            }
        },
        "columns": [
            {
                "field": "image_url",
                "headerName": "URL",
                "width": 200
            },
            {
                "field": "resource_type",
                "headerName": "Resource type",
                "width": 200
            }
        ]
    },
    {
        "title": "Experiences",
        "subtitle": "Offer unique experiences",
        "content_type": "experience",
        "form_schema": {
            "title": "ExperienceTemplateModel",
            "type": "object",
            "properties": {
                "title": {
                    "title": "Title",
                    "type": "string"
                },
                "icon_url": {
                    "title": "Icon Url",
                    "type": "string"
                },
                "picture_url": {
                    "title": "Picture Url",
                    "type": "string"
                },
                "experience_type": {
                    "$ref": "#/definitions/ExperienceTypeEnum"
                },
                "how_does_it_work": {
                    "title": "How Does It Work",
                    "type": "string"
                },
                "subtitle": {
                    "title": "Subtitle",
                    "type": "string"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "enabled": {
                    "title": "Enabled",
                    "type": "boolean"
                },
                "launchdarkly_feature_flag_key": {
                    "title": "Launchdarkly Feature Flag Key",
                    "type": "string"
                }
            },
            "required": [
                "experience_type"
            ],
            "definitions": {
                "ExperienceTypeEnum": {
                    "title": "ExperienceTypeEnum",
                    "description": "An enumeration.",
                    "enum": [
                        "msg",
                        "key",
                        "hid",
                        "cmp",
                        "inq",
                        "cnf",
                        "pci",
                        "ci",
                        "cu",
                        "co",
                        "pco",
                        "ps",
                        "mk",
                        "acc",
                        "sns",
                        "upsell",
                        "crm"
                    ],
                    "type": "string"
                }
            }
        },
        "columns": [
            {
                "field": "title",
                "headerName": "Name",
                "width": 200
            },
            {
                "field": "experience_type",
                "headerName": "Experience type",
                "width": 200
            },
            {
                "field": "icon_url",
                "headerName": "Icon",
                "width": 200,
                "type": "icon"
            },
            {
                "field": "picture_url",
                "headerName": "Header",
                "width": 200,
                "type": "icon"
            }
        ]
    }
]

export const accountTierEnumMap = {
    "free": "free",
    "new": "new",
    "paid": "paid",
    "suspended": "sus",
    "cancelled": "cncl",
    "offboarded": "off"
}

export const currencyEnum = {
    "USD": "USD",
    "AED": "AED",
    "AFN": "AFN",
    "ALL": "ALL",
    "AMD": "AMD",
    "ANG": "ANG",
    "AOA": "AOA",
    "ARS": "ARS",
    "AUD": "AUD",
    "AWG": "AWG",
    "AZN": "AZN",
    "BAM": "BAM",
    "BBD": "BBD",
    "BDT": "BDT",
    "BGN": "BGN",
    "BHD": "BHD",
    "BIF": "BIF",
    "BMD": "BMD",
    "BND": "BND",
    "BOB": "BOB",
    "BOV": "BOV",
    "BRL": "BRL",
    "BSD": "BSD",
    "BTN": "BTN",
    "BWP": "BWP",
    "BYN": "BYN",
    "BZD": "BZD",
    "CAD": "CAD",
    "CDF": "CDF",
    "CHE": "CHE",
    "CHF": "CHF",
    "CHW": "CHW",
    "CLF": "CLF",
    "CLP": "CLP",
    "CNY": "CNY",
    "COP": "COP",
    "COU": "COU",
    "CRC": "CRC",
    "CUC": "CUC",
    "CUP": "CUP",
    "CVE": "CVE",
    "CZK": "CZK",
    "DJF": "DJF",
    "DKK": "DKK",
    "DOP": "DOP",
    "DZD": "DZD",
    "EGP": "EGP",
    "ERN": "ERN",
    "ETB": "ETB",
    "EUR": "EUR",
    "FJD": "FJD",
    "FKP": "FKP",
    "GBP": "GBP",
    "GEL": "GEL",
    "GHS": "GHS",
    "GIP": "GIP",
    "GMD": "GMD",
    "GNF": "GNF",
    "GTQ": "GTQ",
    "GYD": "GYD",
    "HKD": "HKD",
    "HNL": "HNL",
    "HRK": "HRK",
    "HTG": "HTG",
    "HUF": "HUF",
    "IDR": "IDR",
    "ILS": "ILS",
    "INR": "INR",
    "IQD": "IQD",
    "IRR": "IRR",
    "ISK": "ISK",
    "JMD": "JMD",
    "JOD": "JOD",
    "JPY": "JPY",
    "KES": "KES",
    "KGS": "KGS",
    "KHR": "KHR",
    "KMF": "KMF",
    "KPW": "KPW",
    "KRW": "KRW",
    "KWD": "KWD",
    "KYD": "KYD",
    "KZT": "KZT",
    "LAK": "LAK",
    "LBP": "LBP",
    "LKR": "LKR",
    "LRD": "LRD",
    "LSL": "LSL",
    "LYD": "LYD",
    "MAD": "MAD",
    "MDL": "MDL",
    "MGA": "MGA",
    "MKD": "MKD",
    "MMK": "MMK",
    "MNT": "MNT",
    "MOP": "MOP",
    "MRU": "MRU",
    "MUR": "MUR",
    "MVR": "MVR",
    "MWK": "MWK",
    "MXN": "MXN",
    "MXV": "MXV",
    "MYR": "MYR",
    "MZN": "MZN",
    "NAD": "NAD",
    "NGN": "NGN",
    "NIO": "NIO",
    "NOK": "NOK",
    "NPR": "NPR",
    "NZD": "NZD",
    "OMR": "OMR",
    "PAB": "PAB",
    "PEN": "PEN",
    "PGK": "PGK",
    "PHP": "PHP",
    "PKR": "PKR",
    "PLN": "PLN",
    "PYG": "PYG",
    "QAR": "QAR",
    "RON": "RON",
    "RSD": "RSD",
    "RUB": "RUB",
    "RWF": "RWF",
    "SAR": "SAR",
    "SBD": "SBD",
    "SCR": "SCR",
    "SDG": "SDG",
    "SEK": "SEK",
    "SGD": "SGD",
    "SHP": "SHP",
    "SLL": "SLL",
    "SOS": "SOS",
    "SRD": "SRD",
    "SSP": "SSP",
    "STN": "STN",
    "SVC": "SVC",
    "SYP": "SYP",
    "SZL": "SZL",
    "THB": "THB",
    "TJS": "TJS",
    "TMT": "TMT",
    "TND": "TND",
    "TOP": "TOP",
    "TRY": "TRY",
    "TTD": "TTD",
    "TWD": "TWD",
    "TZS": "TZS",
    "UAH": "UAH",
    "UGX": "UGX",
    "XPF": "XPF",
    "ZAR": "ZAR"
}

export const billing_plans = [
    {
        "subscription_id": "nso",
        "name": "Enso Connect",
        "unit": "listing",
        "interval": "month",
        "notion_database_id": "6cbd83413f214ae5ad24a11e084f5005",
        "chargebee_code": "nso"
    },
    {
        "subscription_id": "ah",
        "name": "Autohost - Automation Plan",
        "unit": "booking",
        "interval": "month",
        "notion_database_id": "a4f377c72af443488b6ce79d7abf0651",
        "chargebee_code": "ah"
    },
    {
        "subscription_id": "ahp",
        "name": "Autohost - Automation Plus Plan",
        "unit": "booking",
        "interval": "month",
        "notion_database_id": "b97aad0cae954356bfdb3f4a03c1d2f2",
        "chargebee_code": "ahp"
    },
    {
        "subscription_id": "ahc",
        "name": "Autohost - Background Check Plan",
        "unit": "booking",
        "interval": "month",
        "notion_database_id": "6143fc5857c2438d8f43dd15c1a4ba5f",
        "chargebee_code": "ahc"
    },
    {
        "subscription_id": "sh",
        "name": "Superhog - Verification Plan",
        "unit": "booking",
        "interval": "month",
        "notion_database_id": "e4742f3bfed345d8a1a4f441e863493f",
        "chargebee_code": "sh"
    },
    {
        "subscription_id": "shp",
        "name": "Superhog - Verification + Coverage Plan",
        "unit": "booking",
        "interval": "month",
        "notion_database_id": "f6be7bb3eba44c85be45799b5582a4c6",
        "chargebee_code": "shp"
    },
    {
        "subscription_id": "shg",
        "name": "Truvi - Protection Plan",
        "unit": "night",
        "interval": "month",
        "notion_database_id": "TODO: ADD this later",
        "chargebee_code": "shg"
    },
    {
        "subscription_id": "sms",
        "name": "SMS",
        "unit": "message",
        "interval": "month",
        "notion_database_id": "7d39b03ef17448349b8088c0d5db486c",
        "chargebee_code": "sms"
    },
    {
        "subscription_id": "whs",
        "name": "Whatsapp",
        "unit": "message",
        "interval": "month",
        "notion_database_id": "7d39b03ef17448349b8088c0d5db486c",
        "chargebee_code": "WHATSAPP"
    },
    {
        "subscription_id": "ai",
        "name": "Enso AI",
        "unit": "listing",
        "interval": "month",
        "notion_database_id": "41e105abcb414ff5ad89831c8c5c5fed",
        "chargebee_code": "ai"
    },
    {
        "subscription_id": "dvc",
        "name": "Smart Device",
        "unit": "device",
        "interval": "month",
        "notion_database_id": "c4101452a0134c0cb91f7b6c676208f6",
        "chargebee_code": "dvc"
    },
    {
        "subscription_id": "chk",
        "name": "Chekin",
        "unit": "listing",
        "interval": "month",
        "notion_database_id": "00bda72b9fac46efa619b8f9e2a820c2",
        "chargebee_code": "chk"
    }
]